import { create } from 'zustand'

interface AlertStoreType {
  isAlert: boolean
  alertTitle: string
  alertMessage: string
  alertSubMessage: string
  alertIndicator: any
  alertCaption: string
  alertToggle: (
    visible: boolean,
    title?: string,
    message?: string,
    caption?: string,
    subMessage?: string,
    indicator?: React.JSX.Element
  ) => void

  isConfirm: boolean
  confirmTitle: string
  confirmMessage: string
  confirmCaption: string
  confirmMethod: () => void
  confirmCancelMethod: () => void
  confirmToggle: (
    visible: boolean,
    title?: string,
    message?: string,
    caption?: string,
    confirmMethod?: () => void,
    cancelMethod?: () => void
  ) => void
}

const useAlertStore = create<AlertStoreType>((set) => ({
  isAlert: false,
  alertTitle: '',
  alertMessage: '',
  alertCaption: '',
  alertSubMessage: '',
  alertIndicator: null,

  /**
   * @param visible alert창 출력 여부
   * @param title   alert창 타이틀
   * @param message alert창 메시지
   * @param caption alert창 버튼 내용
   * @param subMessage alert창 서브 메시지
   * @param indicator alert창 시각적 기호 등을 나타내는 ReactNode
   */
  alertToggle: (visible, title, message, caption, subMessage, indicator) => {
    if (!visible) {
      set({ isAlert: false })
      setTimeout(() => {
        set({
          alertTitle: '',
          alertMessage: '',
          alertCaption: '',
          alertSubMessage: '',
          alertIndicator: null,
        })
      }, 500)

      return
    }

    set({
      isAlert: true,
      alertTitle: title || '',
      alertMessage: message || '',
      alertCaption: caption || '',
      alertSubMessage: subMessage || '',
      alertIndicator: indicator || null,
    })
  },

  isConfirm: false,
  confirmTitle: '',
  confirmMessage: '',
  confirmCaption: '',
  confirmMethod: () => {},
  confirmCancelMethod: () => {},
  /**
   * @param visible confirm창 출력 여부
   * @param title   confirm창 타이틀
   * @param message confirm창 메시지
   * @param caption confirm창 버튼 내용
   * @param method  confirm창 ok 버튼 메소드
   * @param cancelMethod  confirm창 cancel 버튼 메소드
   */
  confirmToggle: (visible, title, message, caption, method = () => {}, cancelMethod = () => {}) =>
    set((state) => ({
      isConfirm: visible,
      confirmTitle: title || state.confirmTitle,
      confirmMessage: message || state.confirmMessage,
      confirmCaption: caption || state.confirmCaption,
      confirmMethod: method,
      confirmCancelMethod: cancelMethod,
    })),
}))

export default useAlertStore
